export const CUSTOM_GIFT_CATEGORY_ID = "__customGifts__";
